import Vue from 'vue';
import Vuetify, {
  VApp, VAppBar
} from 'vuetify/lib';

Vue.use(Vuetify, {
  components: {
    VApp, VAppBar
  }
});

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#37474F',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4abc88',
        warning: '#FFC107'
      },
      dark: {
        primary: '#37474F'
      }
    },
  },
});
